import useMount from "hooks/useMount";
import { isDate } from "lodash";

export function ClientDateTime({ date }: { date: Date | null | string }) {
  const mounted = useMount();

  if (!mounted) return null;

  if (!date) {
    return <span>-</span>;
  }

  const dateAsDate = isDate(date) ? date : new Date(date);

  return (
    <span>
      {dateAsDate.toLocaleTimeString([], {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })}
    </span>
  );
}
